import {Component, Input, OnInit} from '@angular/core';
import {AirComponentType} from '../../../afb-api/enums/air-component-type.enum';
import {TemperatureUnit} from '../../../shared';


@Component({
  selector: 'awair-sensor-component',
  templateUrl: './sensor-component.component.html',
  styleUrls: ['./sensor-component.component.scss']
})

export class SensorComponentComponent implements OnInit {
  @Input() sensorColor: string = '#CDD3D8';
  @Input() value: number;
  @Input() componentType: AirComponentType;
  @Input() temperatureUnit: TemperatureUnit;

  constructor() {
  }

  ngOnInit() {
  }
}
